<div class="grid" *ngIf="loading">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{ 'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>

<ng-container *ngIf="!loading">
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div formArrayName="montosPlazos">
      <p-table [value]="rows"
               [columns]="cols"
               [rows]="10"
               [loading]="saving"
               [paginator]="true"
               selectionMode="single"
               dataKey="idProductoPlazoMontoInversion"
               paginatorPosition="bottom">
        <ng-template pTemplate="header">
          <tr>
            <th class="text-center" style="min-width: 300px">{{ 'PRODUCTO.LBL_MONTOS_PLAZOS' | translate }}</th>
            <th *ngFor="let col of cols" class="text-center" style="min-width: 150px;">{{ col.rangoInicial }} - {{ col.rangoFinal }}</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-row>
          <tr>
            <td>{{ row.rangoInicial | dinero:0 }} / {{ row.rangoFinal | dinero:0 }}</td>
            <td *ngFor="let col of cols" pEditableColumn class="text-center" style="max-width: 150px;">
              <ng-container *ngIf="hasIndex(row, col);">
                <div [formGroupName]="getIndexMontoPlazo(row, col)">
                  <p-cellEditor *ngIf="!isDetail">
                    <ng-template pTemplate="input">
                      <input pInputText
                             type="text"
                             formControlName="valor"
                             numero-decimal-reactive
                             [entero]="3"
                             [decimales]="2"
                             [minimo]="0"
                             (blur)="onBlurValor(getIndexMontoPlazo(row, col))">
                    </ng-template>

                    <ng-template pTemplate="output">{{ fMontoPlazo(getIndexMontoPlazo(row, col), 'valor')?.value }} %</ng-template>
                  </p-cellEditor>
                  <ng-container *ngIf="isDetail">{{ fMontoPlazo(getIndexMontoPlazo(row, col), 'valor')?.value }} %</ng-container>
                </div>
              </ng-container>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length" class="text-center">{{ 'MSG_NOHAYREGISTROS' | translate }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <div *ngIf="!isDetail && productoMontosPlazos.length > 0" class="grid form-footer-buttons">
      <div class="form-group col-12">
        <div *ngIf="!saving">
          <a (click)="onCancel()" class="cancelar">{{ 'BTN_CANCELAR' | translate }}</a>
          <button icon="fa fa-plus" label="{{ 'BTN_GUARDAR' | translate }}" type="submit" pButton></button>
        </div>
        <div *ngIf="saving">
          <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
          <span>{{ 'LBL_GUARDANDO' | translate }}</span>
        </div>
      </div>
    </div>
  </form>
</ng-container>

<p-confirmDialog #cd key="producto-montos-plazos-inversion">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
